import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    // static targets = ["minute", "hour", "dayOfMonth", "month", "dayOfWeek"]



    change(event) {
        var target_type = event.target.id
        var cron        = document.getElementById("cron-form")
        var cron_hour   = document.getElementById("cron-hour").value
        var cron_minute = document.getElementById("cron-minute").value
        cron.value = cron_minute + " " + cron_hour + " * * *"
    }

}
